import { colors } from 'Constants/Colors';

const styles = {
  container: {
    alignItems: 'center',
    flex: 5,
    justifyContent: 'flex-end',
  },
  changePasswordButton: {
    backgroundImage: `linear-gradient(to right, ${colors.GREEN}, ${colors.GREEN_SHINING})`,
    '&:hover': {
      backgroundColor: colors.GREEN,
    },
    color: '#FFF',
    paddingTop: '1%',
    paddingBottom: '1%',
    paddingLeft: '8%',
    paddingRight: '8%',
    fontFamily: 'var(--app-font)',
    letterSpacing: '.5rem',
    fontWeight: 'bold',
    flex: 2,
    marginTop: '5%',
  },
  form: {
    flex: 1,
  },
  header: {
    marginTop: '10%',
    marginBottom: '5%',
  },
  backToLogin: {
    marginTop: '1.5rem',
  },
  backToLoginText: {
    color: colors.BLACK,
  },
  textField: {
    marginBottom: '2%',
    width: '25%',
    color: colors.GREEN_SHINING_ULTRA,
  },
};

export default styles;
